module.exports = __webpack_public_path__ + "img/error_forbidden.0b894330.svg";